import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from "rxjs";
import { AppState } from 'src/app/store/app.reducer';
import { DEFAULT_LANG, LANGUAGES } from 'src/app/conf/languages';
import { Lang } from 'src/app/model/lang';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Ticket } from 'src/app/model/ticket';

@Component({
	templateUrl: './ticket-details.dialog.component.html',
})
export class TicketDetailsDialogComponent {

	currentLang$: Observable<Lang> = new Observable();
	currentLangSub: Subscription  | undefined;
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;
	ticket: Ticket;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,
	){
		this.ticket = config.data.ticket;
	}

}
